// The ERP catalogue shared by the declarant request page and the admin demand
// view. Mirrors the backend enums in src/utils/validaton/erpIntegrationRequest.zod.ts
// (backend docs/features/erp-integration-requests, D6).

// Product names are proper nouns: never translated. `other` is labelled by the caller.
export const ERP_SYSTEM_NAMES = {
  sap_s4hana: 'SAP S/4HANA',
  sap_ecc: 'SAP ECC',
  sap_business_one: 'SAP Business One',
  ms_dynamics_365: 'Microsoft Dynamics 365',
  oracle_netsuite: 'Oracle NetSuite',
  sage: 'Sage',
  odoo: 'Odoo',
};
export const ERP_SYSTEMS = [...Object.keys(ERP_SYSTEM_NAMES), 'other'];
export const ERP_HOSTING = ['cloud', 'on_premise'];
export const ERP_SYNC_DATA = ['purchases', 'suppliers', 'imports'];
